<template>
    <div class="container-resizable" style="background-color: #ffffff;">
        <div class="container-logos">
            <h2 class="p-text-center">{{$t("messages.nuestrosConvenios")}}</h2>
            <img src="/assets/layout/images/logo1.png" alt="seguros sura logo" class="logo-convenio">
            <img src="/assets/layout/images/logo2.jpeg" alt="pan american life logo" class="logo-convenio">
            <img src="/assets/layout/images/logo3.jpg" alt="famisanar logo" class="logo-convenio">
            <img src="/assets/layout/images/logo4.png" alt="seguros bolivar logo" class="logo-convenio">
            <img src="/assets/layout/images/logo5.png" alt="Liberty seguros logo" class="logo-convenio">
            <img src="/assets/layout/images/logo6.png" alt="Allianz logo" class="logo-convenio">
            <img src="/assets/layout/images/logo7.png" alt="Coomeva logo" class="logo-convenio">
            <img src="/assets/layout/images/logo8.png" alt="salud total logo" class="logo-convenio">
            <img src="/assets/layout/images/logo9.png" alt="HDI seguros logo" class="logo-convenio">
        </div>
    </div>
</template>

<script>
export default {
    name: "Convenios"
}
</script>

<style lang="scss" scoped>
.container-resizable {
    justify-content: center;
    background-color: #FFFFFF;
    padding-top: 80px;
    padding-bottom: 80px;
}

.container-logos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}


.logo-convenio {
    height: 60px;
    width: auto;
    margin: 20px 40px;
}

h2 {
    width: 100%;
    margin-bottom: 50px;
    color: #083078;
    font-size: 40px;
    font-weight: bolder;
}

@media screen and (max-width: 1540px) {
    .container-resizable {
        padding: 30px 10px;
    }
}

@media screen and (max-width: 460px) {
    .logo-convenio {
        height: auto;
        width: 50vw;
        margin:0px auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
}
</style>